<template>
  <v-row align="center" justify="center">
    <v-col cols="12">
      <v-card>
        <v-card-title class="d-flex justify-space-between">
          <span>
            Lottery list
          </span>
          <v-btn
            small
            color="primary"
            :to="{ name: $routes.admin.lottery.createRoute.name }"
          >
            Create Lottery
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-data-table
            :loading="loading"
            :headers="tableColumns"
            :items="lotteries"
          >
            <template v-slot:item.action="{ item }">
              <v-btn icon @click="editLottery(item)">
                <font-awesome-icon icon="pencil-alt"></font-awesome-icon>
              </v-btn>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import ContentLoader from "../../../mixins/ContentLoader.js";
import { fetchLotteries } from "../../../../api/lottery.api";

export default {
  name: "LotteryIndex",
  mixins: [ContentLoader],
  data() {
    return {
      lotteries: [],
      tableColumns: [
        {
          text: "Name",
          value: "name"
        },
        {
          text: "Actions",
          value: "action"
        }
      ]
    };
  },
  async mounted() {
    this.$startLoading();

    try {
      const result = await fetchLotteries(),
        { lotteries } = result.data;

      this.lotteries = lotteries;

      await this.$nextTick();
    } catch (e) {
      console.error(e);
    } finally {
      this.$finishedLoading();
    }
  },
  methods: {
    editLottery({ id }) {
      this.$router.push({
        name: this.$routes.admin.lottery.editRoute.name,
        params: { id }
      });
    }
  }
};
</script>

<style scoped></style>
